import { Group, Text, useMantineTheme } from "@mantine/core"
import { IconCheck } from "@tabler/icons-react"
import { Tooltip } from "@tfg/ui"
import { useTranslation } from "react-i18next"

export type NonEligibleProductTooltipCopy = {
  readonly tooltipLabel: string
  readonly rowLabel: string
  readonly iconColor: string
}

/**
 * Copy and styling for AGEC-not-eligible (null step) compliance cell + tooltip.
 */
export const useNonEligibleProductTooltip =
  (): NonEligibleProductTooltipCopy => {
    const { t } = useTranslation("products")
    const theme = useMantineTheme()

    return {
      tooltipLabel: t("lists.cells.agec.tooltips.notApplicable"),
      rowLabel: t("lists.cells.agec.notApplicable"),
      iconColor: theme.colors.gray[6],
    }
  }

/**
 * Grey check + short label; hover shows the non-applicable regulation tooltip.
 */
export const NonEligibleProductTooltip = () => {
  const { tooltipLabel, rowLabel, iconColor } = useNonEligibleProductTooltip()

  return (
    <Tooltip
      label={tooltipLabel}
      withArrow
      openDelay={400}
      maw={380}
      styles={{
        tooltip: {
          backgroundColor: "var(--mantine-color-body)",
          color: "var(--mantine-color-text)",
          border: "1px solid var(--mantine-color-gray-4)",
          borderRadius: "var(--mantine-radius-md)",
        },
        arrow: {
          backgroundColor: "var(--mantine-color-body)",
        },
      }}
    >
      <Group gap={4} wrap="nowrap" style={{ width: "fit-content" }}>
        <IconCheck size={16} color={iconColor} />
        <Text fz="xs">{rowLabel}</Text>
      </Group>
    </Tooltip>
  )
}
